"use client";
import { jsx as C } from "react/jsx-runtime";
import { memo as t, forwardRef as n } from "react";
import { useSvgIcon as e } from "../useSvgIcon.js";
const l = t(
  n((o, r) => {
    const i = e({
      ...o,
      ref: r
    });
    return /* @__PURE__ */ C(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i(),
        children: /* @__PURE__ */ C(
          "path",
          {
            d: "M20.211 16C20.211 18.322 18.322 20.211 16 20.211C13.678 20.211 11.789 18.322 11.789 16C11.789 13.678 13.678 11.789 16 11.789C18.322 11.789 20.211 13.678 20.211 16ZM16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C18.828 30 21.555 29.158 23.886 27.565L23.926 27.537L22.04 25.345L22.008 25.365C20.214 26.52 18.136 27.13 16 27.13C9.863 27.13 4.87 22.137 4.87 16C4.87 9.863 9.863 4.87 16 4.87C22.137 4.87 27.13 9.863 27.13 16C27.13 16.795 27.041 17.6 26.868 18.392C26.516 19.837 25.504 20.279 24.745 20.221C23.981 20.159 23.087 19.615 23.081 18.283V17.268V16C23.081 12.095 19.905 8.919 16 8.919C12.095 8.919 8.919 12.095 8.919 16C8.919 19.905 12.095 23.081 16 23.081C17.897 23.081 19.676 22.34 21.017 20.991C21.797 22.205 23.068 22.966 24.515 23.082C24.639 23.092 24.766 23.097 24.891 23.097C25.91 23.097 26.919 22.756 27.733 22.139C28.572 21.501 29.199 20.58 29.545 19.473C29.6 19.294 29.702 18.885 29.702 18.882L29.705 18.867C29.909 17.979 30 17.094 30 16C30 8.28 23.72 2 16 2Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
l.displayName = "IconfMailRu";
export {
  l as IconfMailRu
};
